<div class="row">
  <div class="details-container">
    <mat-icon class="back-button" svgIcon="arrow-back" (click)="navigateBack()"></mat-icon>
    <div class="t9 bold center header">Welcome, {{ userName }}. Please enter a new PIN.</div>
    <div *ngIf="loginError" class="form-row mb-2">
      <div class="col-12">
        <alert type="danger" dismissible="true" (onClosed)="onClosed(alert)">{{ alert }}</alert>
      </div>
    </div>
    <h1 class="pin-entry">{{ pinEntry }}</h1>
  </div>
  <div class="keyboard-container">
    <app-custom-keyboard class="pinKeyboard" #pinKeyboard [template]="pinTemplate" (typedValue)="typedText($event)">
    </app-custom-keyboard>
  </div>
</div>